import React, { useState } from 'react';
import Modal from '../../Shared/Modal';

const categoryOptions = [
  { label: 'Appetisers', description: 'Starters, small plates, and bites' },
  { label: 'Soups', description: 'Broths, creamy or chunky soups' },
  { label: 'Salads', description: 'Fresh salads and dressings' },
  { label: 'Main Courses', description: 'Main meals and entrées' },
  { label: 'Sides', description: 'Accompaniments and extras' },
  { label: 'Breads', description: 'Loaves, rolls, and pastries' },
  { label: 'Cakes', description: 'Cakes, puddings, and bakes' },
  { label: 'Sweets', description: 'Desserts, sweets, and candy' },
  { label: 'Drinks', description: 'Smoothies, teas, and beverages' },
  { label: 'Sauces', description: 'Preserves, sauces, and dips' },
  { label: 'Snacks', description: 'Light bites and finger foods' },
  { label: 'Breakfast', description: 'Morning meals and brunch' },
  { label: 'Veg & Vegan', description: 'Plant-based & vegetarian recipes' },
  { label: 'Free-From', description: 'Gluten-free, dairy-free, etc.' },
  { label: 'Kids', description: 'Child-friendly meals and treats' },
  { label: 'Holiday Picks', description: 'Festive or seasonal favourites' },
  { label: 'World Foods', description: 'Global cuisines and classics' },
];

function RecipeCategory({ category, onChange, readOnly }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="h-full w-full flex flex-col items-center justify-center px-[3%] text-center text-[#5a3e36]">
      <label
        htmlFor="categorySelect"
        className="text-[clamp(0.65rem,1.2vw,0.875rem)] font-semibold leading-tight mb-[1%]"
      >
        Category:
      </label>

      {readOnly ? (
        <div className="text-[clamp(0.65rem,1.2vw,0.875rem)] font-normal leading-tight truncate max-w-full">
          {category?.trim() || <span className="text-transparent select-none">.</span>}
        </div>
      ) : (
        <div
          className="
            w-full max-w-[90vw] sm:max-w-[24rem] md:max-w-[20rem]
            h-[clamp(1.8rem,2.2rem,2rem)]
            text-[clamp(0.65rem,1.2vw,0.875rem)]
            border border-[#e0c3a5] rounded
            bg-white flex items-center justify-center
            cursor-pointer select-none
          "
          onClick={() => setIsModalOpen(true)}
        >
          {category || <span className="text-transparent select-none">.</span>}
        </div>
      )}

      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} title="Select Category">
        <div className="flex flex-col gap-2 max-h-[70vh] overflow-y-auto">
          {categoryOptions.map(({ label, description }) => (
            <button
              key={label}
              className={`
                px-4 py-2 text-left rounded border border-dominant-purple
                hover:bg-rich-gold hover:text-white transition duration-200
                text-[0.875rem] font-marketing
                ${label === category
                  ? 'bg-rich-gold text-white shadow-inner ring-1 ring-white/40'
                  : 'bg-white text-charcoal'}
              `}
              onClick={() => {
                onChange(label);
                setIsModalOpen(false);
              }}
            >
              <div className="font-semibold">{label}</div>
              <div
                className={`text-[0.75rem] ${
                  label === category ? 'text-white/80' : 'text-slate-500'
                }`}
              >
                {description}
              </div>
            </button>
          ))}
        </div>
      </Modal>
    </div>
  );
}

export default RecipeCategory;